<template>
  <component
    :is="tag"
  >
    <slot />
  </component>
</template>

<script>
import events  from '@/js/util/events.js'

export default {
  provide () {
    return {
      [events]: this,
    }
  },
  props: {
    tag: {
      type: String,
      default: 'div',
    }
  },
}
</script>
